<template>
  <q-btn
    ref="button"
    :label="isEmpty(column.filter) ? column.label : `${column.label}: ${getFilterValues}`"
    :class="[{
      'filter-button': true,
      'selected': !isEmpty(column.filter),
      'highlighted': highlightedButton === column.name
    }]"
    icon-right="keyboard_arrow_down"
    flat
    no-caps
  >
    <q-popover
      ref="popover"
      @show="highlightButton(column.name)"
      @hide="releaseButton()"
      :offset="popperOffset"
    >
      <rangedate-picker :value="this.column.filter" @selected="(dateRange) => { setDateFilter(dateRange); search() }"/>
    </q-popover>
  </q-btn>

</template>

<script>
  import {
    QBtn,
    QPopover,
    QInput,
    //QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar';

  import TableFilterBase from './TableFilterBase';
  import RangedatePicker from '@/RangedatePicker';

  export default {
    name: 'TableFilterDate',
    components: {
      QBtn,
      QPopover,
      QInput,
      //QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon,
      RangedatePicker
    },
    extends: TableFilterBase,
    props: {
      column: {
        type: Object,
        default: {}
      },
      columns: {
        type: Array,
        default: []
      }
    },
    methods: {
      setDateFilter (dateRange) {
        if (!dateRange.start && !dateRange.end) {
          this.column.filter = {};
          return;
        }

        if (dateRange.start && dateRange.end && dateRange.start.getTime() === dateRange.end.getTime()) {
          this.column.filter = Object.assign({}, this.column.filter, {
            from: this.formatDate(date.formatDate(dateRange.start, 'YYYY-MM-DD'))
          });

          delete this.column.filter.to;
        } else {
          this.column.filter = Object.assign({}, this.column.filter, {
            from: this.formatDate(date.formatDate(dateRange.start, 'YYYY-MM-DD')),
            to: this.formatDate(date.formatDate(dateRange.end, 'YYYY-MM-DD'))
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilterDate.vue